import { MdOutlineNotificationsNone } from 'react-icons/md'

import { notificationKindByCode } from '../Contracts/NotificationKinds'

import type { HistoryTone } from '@/Ship/Components/History'
import type { ReactNode } from 'react'
import type { Notification } from '../Stores/NotificationStore'

export interface NotificationKind {
    label: string
    icon: ReactNode
    tone: HistoryTone
}

/**
 * Як показати подію: підпис, значок і тон — за кодом із каталогу
 * (`NotificationKinds.ts`, ADR 040).
 *
 * Невідомий код (чи сповіщення без коду, створене до появи поля) — нейтральний
 * показ із заголовком сповіщення як підписом. Вид події за текстом заголовка
 * не розпізнаємо: перейменували заголовок — сповіщення втратило б значок.
 */
export const notificationKind = (item: Pick<Notification, 'code' | 'title'>): NotificationKind => {
    const kind = notificationKindByCode(item.code)

    if (!kind) {
        return { label: item.title, icon: <MdOutlineNotificationsNone />, tone: 'neutral' }
    }

    const Icon = kind.icon

    return { label: kind.label, icon: <Icon />, tone: kind.tone }
}

export interface NotificationEntity {
    /** Ресурс для картки — він же `entityCode`. */
    resource: string
    uuid: string
    /** Підпис посилання — текст сповіщення. */
    label: string
}

/**
 * Запис, про який сповіщення, — для посилання.
 *
 * Номер і назву запису з тексту не витягуємо: посилання веде за
 * `entityCode` + `entityUuid`, а підписом стає текст сповіщення як є.
 */
export const notificationEntity = (item: Notification): NotificationEntity | null => {
    if (!item.entityCode || !item.entityUuid) return null

    return {
        resource: item.entityCode,
        uuid: item.entityUuid,
        label: item.message,
    }
}
